import React, { useRef, useEffect } from "react";
import styled from "styled-components";
import { EditorState, Modifier } from "draft-js";
import { FlexColumn, FlexRow, Icon } from "../..";
import { useTextEditorContext, ToggleOption, emojisArray, parseEmoji } from ".";
export const EmojiPicker = ({
  editorState,
  onChange,
  handleFocus,
  emojiList = emojisArray
}) => {
  const {
    editorFocus,
    emojiModal,
    setEmojiModal
  } = useTextEditorContext();
  const popupRef = useRef();

  const handleOpen = () => {
    setEmojiModal(true);
  };

  const handleClose = () => {
    setEmojiModal(false);
  };

  const addEmoji = emojiCharacterString => {
    const parsedEmoji = parseEmoji(emojiCharacterString);
    const newContent = Modifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), parsedEmoji);
    const newEditorState = EditorState.push(editorState, newContent, "insert-characters");
    onChange(EditorState.forceSelection(newEditorState, newContent.getSelectionAfter()));
    handleClose();
    setTimeout(() => {
      handleFocus();
    }, 0);
  };

  const handleClickOut = e => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      handleClose();
    }
  };

  useEffect(() => {
    if (emojiModal) {
      popupRef.current.scrollTo(0, 0);
      document.addEventListener("mousedown", handleClickOut, {
        capture: true
      });
      return () => {
        document.removeEventListener("mousedown", handleClickOut);
      };
    }
  }, [emojiModal]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmojiContainer, {
    active: emojiModal,
    ref: popupRef
  }, /*#__PURE__*/React.createElement(EmojiInner, null, emojiList.map(item => /*#__PURE__*/React.createElement(Emoji, {
    key: item,
    onMouseDown: () => addEmoji(item)
  }, parseEmoji(item))))), /*#__PURE__*/React.createElement(ToggleOption, {
    active: emojiModal,
    icon: /*#__PURE__*/React.createElement(Icon, {
      selector: true,
      name: "Emoji"
    }),
    onClick: handleOpen,
    editorFocus: editorFocus
  }));
};
const EmojiContainer = styled(FlexColumn)`
  background-color: #ffffff;
  border-radius: 2px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.48);
  height: 184px;
  width: 425px;
  opacity: ${props => props.active ? 1 : 0};
  overflow: hidden;
  overflow-y: scroll;
  transition: all 0.2s ease;
  visibility: ${props => props.active ? "visible" : "hidden"};
  padding: 12px 2px 12px 16px;
  position: absolute;
  bottom: 0;
  left: -4px;
  z-index: 100;
  &::-webkit-scrollbar {
    width: 14px;
  }
  &::-webkit-scrollbar-thumb {
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 9999px;
    background-color: #aaaaaa;
  }
`;
const EmojiInner = styled(FlexRow)`
  flex-wrap: wrap;
  justify-content: space-around;
`;
const Emoji = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  font-family: "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-size: 32px;
  line-height: 32px;
  padding: 6px 8px;
  width: 32px;
  &:hover {
    text-shadow: 0 0 5px rgb(0 0 0 / 32%);
  }
`;